dmx.Component('bs5-offcanvas', {

  initialData: {
    visible: false
  },

  attributes: {
    show: {
      type: Boolean,
      default: false
    },

    backdrop: {
      type: [Boolean, String],
      default: true
    },

    nokeyboard: {
      type: Boolean,
      default: false
    },

    scroll: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    toggle () {
      requestAnimationFrame(() => this._instance.toggle());
    },

    show () {
      requestAnimationFrame(() => this._instance.show());
    },

    hide () {
      requestAnimationFrame(() => this._instance.hide());
    }
  },

  events: {
    show: Event,
    shown: Event,
    hide: Event,
    hidden: Event
  },

  init (node) {
    this._showHandler = this._showHandler.bind(this);
    this._shownHandler = this._shownHandler.bind(this);
    this._hideHandler = this._hideHandler.bind(this);
    this._hiddenHandler = this._hiddenHandler.bind(this);

    node.addEventListener('show.bs.offcanvas', this._showHandler);
    node.addEventListener('shown.bs.offcanvas', this._shownHandler);
    node.addEventListener('hide.bs.offcanvas', this._hideHandler);
    node.addEventListener('hidden.bs.offcanvas', this._hiddenHandler);

    node.classList.toggle('show', this.props.show);
    this.set('visible', this.props.show);

    let backdrop = this.props.backdrop;
    if (backdrop != 'static') {
      backdrop = backdrop != 'false';
    }

    this._instance = new bootstrap.Offcanvas(node, {
      backdrop: backdrop,
      keyboard: !this.props.nokeyboard,
      scroll: this.props.scroll
    });
  },

  destroy () {
    this.$node.removeEventListener('show.bs.offcanvas', this._showHandler);
    this.$node.removeEventListener('shown.bs.offcanvas', this._shownHandler);
    this.$node.removeEventListener('hide.bs.offcanvas', this._hideHandler);
    this.$node.removeEventListener('hidden.bs.offcanvas', this._hiddenHandler);

    this._instance.dispose();
  },

  performUpdate (updatedProps) {
    if (updatedProps.has('show')) {
      this.$node.classList.toggle('show', this.props.show);
      this.set('visible', this.props.show);
    }
  },

  _showHandler () {
    this.set('visible', true);
    this.dispatchEvent('show');
  },

  _shownHandler () {
    this.dispatchEvent('shown');
  },

  _hideHandler () {
    this.dispatchEvent('hide');
  },

  _hiddenHandler () {
    this.set('visible', false);
    this.dispatchEvent('hidden');
  },

});